
import global from 'Core/global';
import utils from 'Utils/utils';

export default {
	focus (which = 'first', items = [], index = 0, continuous = false) {
		if (global.state.nav === 'mobile') {
			return;
		}
		switch (which) {
		case 'first':
			// setFocus(items[0]);
			break;
		case 'last':
			setFocus(items[items.length-1]);
			break;
		case 'prev':
			if (continuous && !items[index-1]) {
				setFocus(items[items.length-1]);
			} else {
				setFocus(items[index-1]);
			}
			break;
		case 'next':
			if (continuous && !items[index+1]) {
				setFocus(items[0]);
			} else {
				setFocus(items[index+1]);
			}
			break;
		default:
			if (utils.isNumber(which)) {
				setFocus(items[which]);
			}
		}

		function setFocus (item) {
			if (item && item.focus) {
				setTimeout(() => {
					item.focus();
				}, 1);
			}
		}

	},
	key (self, node, params) {

		node.addEvent('keydown', event => {
			switch (event.which) {
			case 9:
				if (params.tab && global.state.nav === 'desktop') {
					event.preventDefault();
				}
				run('tab', event);
				break;
			case 13: // Enter
			case 32: // Space

				if (document.activeElement.nodeName === 'LABEL' && document.activeElement.getAttribute('aria-expanded') === null) {
					event.preventDefault();
					run('enter', event);
				} else if (document.activeElement.nodeName === 'LABEL' && document.activeElement.getAttribute('aria-expanded') === 'true') {
					event.preventDefault();
					run('escSub', event);
				}
				break;
			case 27: // Escape
				run('esc', event);
				break;
			case 35: // End
				run('end', event);
				break;
			case 36: // Home
				run('home', event);
				break;
			case 37: // Left
				if (global.state.nav === 'desktop') {
					event.preventDefault();
					run('left', event);
				}
				break;
			case 38: // Up
				if (global.state.nav === 'desktop') {
					event.preventDefault();
					run('up', event);
				}
				break;
			case 39: // Right
				if (global.state.nav === 'desktop') {
					event.preventDefault();
					run('right', event);
				}
				break;
			case 40: // Down
				if (global.state.nav === 'desktop') {
					event.preventDefault();
					run('down', event);
				}
				break;
			default:
				// Character
				run('char', event);
			}
		});

		function run (method, event) {
			if (utils.isFunction(params[method])) {
				params[method].call(self, event);
			}

		}

	},
	getIndexOfString (key, strings) {

		if (!utils.isNotEmptyString(key) || !utils.isArray(strings)) {
			return;
		}

		key = key.toLocaleLowerCase();

		for (let index = 0; index < strings.length; index++) {

			if (strings[index].toLocaleLowerCase().startsWith(key)) {

				return index;

			}

		}

	}
};
